import React from "react";
import PropTypes from "prop-types";
import { formatDate } from "utils/dates";
import { PatientProfileContext } from "components/profile/context";

function SelectOrderProductLineModal({
  onCreateOrder,
  patient_product_lines,
  closeSelf
}) {
  const { fetchPatientHCPCHistoryAPI } = React.useContext(
    PatientProfileContext
  );

  const hcpcHistoryData = fetchPatientHCPCHistoryAPI.response?.eligiblity ?? [];

  const getMostRecentEligibleItem = productLine => {
    const itemsForProductLine = hcpcHistoryData?.filter(item => {
      return item.productLine === productLine && item.productType != "Machine";
    });
    if (itemsForProductLine?.length === 0) return { isEligible: true };

    const sortedItems = itemsForProductLine.sort((a, b) => {
      const dateA = new Date(a.eligibilityDate);
      const dateB = new Date(b.eligibilityDate);
      return dateA - dateB;
    });

    const mostRecent = sortedItems[0];
    return mostRecent;
  };

  // Helper function to get eligibility status display
  const getEligibilityStatus = item => {
    if (!item || item.isEligible) {
      return {
        text: "✓ Currently Eligible",
        color: "green",
        bgColor: "#e8f5e8",
        borderColor: "#28a745"
      };
    } else if (item.isSoonEligible) {
      return {
        text: "⏰ Eligible Soon",
        color: "orange",
        bgColor: "#fff3cd",
        borderColor: "#ffc107"
      };
    } else {
      return {
        text: "⚠ Not Currently Eligible",
        color: "red",
        bgColor: "#ffe6e6",
        borderColor: "#dc3545"
      };
    }
  };
  const modalRef = React.useRef(null);
  React.useEffect(() => {
    // Close profile menu when this modal is opened
    modalRef.current?.click();
  }, [modalRef]);
  return (
    <div
      style={{
        padding: 10,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
      }}
      ref={modalRef}
    >
      <h3>Select Product Line</h3>
      <p style={{ fontSize: 16 }}>
        Choose the product line you would like to order for this patient.
      </p>
      {patient_product_lines.map(x => {
        const earliestEligibleItem = getMostRecentEligibleItem(x.text);
        const eligibilityStatus = getEligibilityStatus(earliestEligibleItem);

        return (
          <div
            key={x.text}
            style={{
              display: "grid",
              gridTemplateColumns: "200px 400px",
              marginBottom: 15,
              alignItems: "center",
              gridGap: 20,
              padding: "10px",
              border: "1px solid #ddd",
              borderRadius: "5px",
              backgroundColor: earliestEligibleItem?.isEligible
                ? "#f0f8f0"
                : "#fff"
            }}
          >
            <div>
              <button
                style={{ margin: 0, width: "100%" }}
                onClick={() => {
                  onCreateOrder(x.text);
                  closeSelf();
                }}
              >
                Order {x.text} Supplies
              </button>
            </div>
            <div style={{ fontSize: 14 }}>
              <div>
                {eligibilityStatus && (
                  <div
                    style={{
                      fontSize: "12px",
                      color: eligibilityStatus.color,
                      fontWeight: "bold",
                      marginTop: "5px",
                      padding: "3px 6px",
                      borderRadius: "3px",
                      backgroundColor: eligibilityStatus.bgColor,
                      border: `1px solid ${eligibilityStatus.borderColor}`
                    }}
                  >
                    {eligibilityStatus.text}
                  </div>
                )}
                {!earliestEligibleItem.isEligible && (
                  <div style={{ marginTop: "5px" }}>
                    <strong>Eligibility Date:</strong>{" "}
                    <span
                      style={{
                        color: eligibilityStatus?.color || "black",
                        fontWeight: "bold"
                      }}
                    >
                      {formatDate(earliestEligibleItem.eligibilityDate)}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
SelectOrderProductLineModal.propTypes = {
  onCreateOrder: PropTypes.func.isRequired,
  closeSelf: PropTypes.func.isRequired,
  patient_product_lines: PropTypes.array.isRequired,
  patientInfo: PropTypes.object.isRequired
};

export default SelectOrderProductLineModal;
